import { ZoomState } from "./types";

const state: ZoomState = {
  meetings: {},
};

export default state;
